import React from "react";

const HeaderNotificationIcon = ({ stroke }: { stroke: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.25 16V16.3107L17.4697 16.5303L19.1893 18.25H4.81066L6.53033 16.5303L6.75 16.3107V16V11C6.75 8.18156 8.21828 5.99138 10.6729 5.4098L11.25 5.27306V4.68V4C11.25 3.58421 11.5842 3.25 12 3.25C12.4158 3.25 12.75 3.58421 12.75 4V4.68V5.27259L13.3265 5.40966C15.7722 5.99115 17.25 8.19222 17.25 11V16ZM12.9973 20.75C12.7683 21.0529 12.4054 21.25 12 21.25C11.5897 21.25 11.2272 21.0533 10.9997 20.75H12.9973Z"
        fill="white"
        stroke={stroke ? stroke : "white"}
        stroke-width="1.5"
      />
      <circle cx="17" cy="6" r="4.5" fill="#D9192F" stroke="white" />
    </svg>
  );
};

export default HeaderNotificationIcon;
